// extracted by mini-css-extract-plugin
export default {"container":"lucide_container__EKke7","form":"lucide_form__Nv4yD","divedit":"lucide_divedit__W4roI","inputDiv":"lucide_inputDiv__sxegg","inputDesc":"lucide_inputDesc__H-4vy"};